import { memo } from 'react';
import { KeyboardLayouts } from '../../SimpleKeyboard/Layout';
import { isElectron } from '../../../helpers/EnvironmentFlags/EnvironmentFlags';
import { KioskFormVinField } from './KioskFormVinField/KioskFormVinField';
import { WebFormVinField } from './WebFormVinField/WebFormVinField';
import { FormVinFieldProps } from './FormVinField.types';

const FormVinField = memo(({
    name,
    id,
    title,
    label,
    ariaLabel,
    disabled,
    required = false,
    autoFocus,
    initiallyMasked = false,
    keyboardLayout = KeyboardLayouts.AlphanumericNumpad,
    shiftAfterSpace = false,
    shiftAfterPeriod = false,
    shiftAfterAmpersand = false,
    hideKeyboardOnClickOut = false,
    capsLock = false,
    fullWidth = false,
    seventyFivePercentWidth = false,
    tabFocusRefContext,
    onChangeCallback,
    vinType,
}: FormVinFieldProps) => {

    return (
        isElectron() ? (
            <KioskFormVinField
                name={name}
                id={id}
                title={title}
                label={label}
                ariaLabel={ariaLabel}
                disabled={disabled}
                required={required}
                autoFocus={autoFocus}
                initiallyMasked={initiallyMasked}
                keyboardLayout={keyboardLayout}
                shiftAfterSpace={shiftAfterSpace}
                shiftAfterPeriod={shiftAfterPeriod}
                shiftAfterAmpersand={shiftAfterAmpersand}
                hideKeyboardOnClickOut={hideKeyboardOnClickOut}
                capsLock={capsLock}
                fullWidth={fullWidth}
                seventyFivePercentWidth={seventyFivePercentWidth}
                tabFocusRefContext={tabFocusRefContext}
                onChangeCallback={onChangeCallback}
                vinType={vinType}
            />
        ) : (
            <WebFormVinField
                name={name}
                id={id}
                title={title}
                label={label}
                ariaLabel={ariaLabel}
                disabled={disabled}
                required={required}
                autoFocus={autoFocus}
                initiallyMasked={initiallyMasked}
                capsLock={capsLock}
                fullWidth={fullWidth}
                seventyFivePercentWidth={seventyFivePercentWidth}
                tabFocusRefContext={tabFocusRefContext}
                onChangeCallback={onChangeCallback}
                vinType={vinType}
            />
        )
    );
},
);

export default FormVinField;
